<template>
    <div class="modal-overlay" v-if="abrirModal == id">
        <div class="modal-content">
            <div class="modal-icon">
                <div class="outer-circle"></div>
                <div class="middle-circle"></div>
                <div class="inner-circle">
                    <div class="inner-border">!</div>
                </div>
            </div>
            <div class="modal-header">
                <h4>{{titulo}}</h4>
            </div>
            <div class="modal-body">
                <p class="subtitle" v-if="mensagem">
                    {{ mensagem }}<br/>
                </p>    
                <p>
                    {{labelOpcoes}}
                </p> 
            </div>
            <div class="modal-footer">
                <button v-for="(botao, index) in botoes" :key="index" @click="executar(botao)">{{botao.texto}}</button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
    props: ['titulo', 'mensagem', 'botoes', 'labelOpcoes', 'id'],
    computed: {
        ...mapGetters({
            abrirModal: 'GET_MODAL_AVISO'
        })
    },
    methods: {
        executar(botao){
            if (typeof botao.acao === 'function') {
                botao.acao();
                this.closeModal();
            } else if (botao.emit) {
                this.closeModal();
            }
        },
        closeModal() {
            this.$store.commit('SET_MODAL_AVISO', false);
            
        }
    }
};
</script>

<style scoped>
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 9999;
    padding: 1rem;
}

.modal-content {
    background: white;
    border-radius: 12px;
    padding: 2rem;
    max-width: 500px;
    width: 100%;
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1.5rem;
}

.dark .modal-content {
    background: #1e293b;
    color: #f1f5f9;
}

.modal-icon {
    position: relative;
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.outer-circle {
    position: absolute;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background: #fef3c7;
}

.dark .outer-circle {
    background: #78350f;
}

.middle-circle {
    position: absolute;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background: #fde68a;
}

.dark .middle-circle {
    background: #92400e;
}

.inner-circle {
    position: relative;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    background: #f59e0b;
    display: flex;
    align-items: center;
    justify-content: center;
}

.dark .inner-circle {
    background: #f59e0b;
}

.inner-border {
    font-size: 32px;
    font-weight: bold;
    color: white;
    line-height: 1;
}

.modal-header {
    text-align: center;
    width: 100%;
}

.modal-header h4 {
    font-size: 1.5rem;
    font-weight: 600;
    margin: 0;
    color: #1f2937;
}

.dark .modal-header h4 {
    color: #f1f5f9;
}

.modal-body {
    text-align: center;
    width: 100%;
}

.modal-body .subtitle {
    font-weight: 500;
    margin-bottom: 0.5rem;
    color: #374151;
}

.dark .modal-body .subtitle {
    color: #d1d5db;
}

.modal-body p {
    color: #6b7280;
    line-height: 1.6;
    margin: 0;
}

.dark .modal-body p {
    color: #9ca3af;
}

.modal-footer {
    display: flex;
    gap: 0.75rem;
    width: 100%;
    flex-direction: column;
}

.modal-footer button {
    padding: 0.75rem 1.5rem;
    border-radius: 8px;
    font-weight: 500;
    font-size: 0.95rem;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    width: 100%;
}

.modal-footer button:first-child {
    background: #f59e0b;
    color: white;
}

.modal-footer button:first-child:hover {
    background: #d97706;
}

.modal-footer button:not(:first-child) {
    background: #f3f4f6;
    color: #374151;
}

.dark .modal-footer button:not(:first-child) {
    background: #374151;
    color: #f3f4f6;
}

.modal-footer button:not(:first-child):hover {
    background: #e5e7eb;
}

.dark .modal-footer button:not(:first-child):hover {
    background: #4b5563;
}

@media (min-width: 640px) {
    .modal-footer {
        flex-direction: row;
    }
    
    .modal-footer button {
        width: auto;
        flex: 1;
    }
}
</style>
